export const INIT_PRACTITIONER_REPORTS = 'INIT_PRACTITIONER_REPORTS';
